import { Text } from '@mantine/core';

import formatDate from '@/utils/formatDate';

import classes from './ClinicalNotes.module.scss';

interface DateCellProps {
  value: string;
}

export const DateCell = ({ value }: DateCellProps) => {
  const date = new Date(value);
  const formattedDate = formatDate(date, 'MM/DD/YY');
  const formattedTime = formatDate(date, 'HH:mm:ss');

  return (
    <div className={classes.dateCell}>
      <Text className={classes.dateValue}>{formattedDate}</Text>
      <Text className={classes.timeValue}>{formattedTime}</Text>
    </div>
  );
};

interface OwnerCellProps {
  value: {
    given: string;
    family: string;
  };
}

export const OwnerCell = ({ value }: OwnerCellProps) => {
  return (
    <Text className={classes.ownerValue}>
      {value.given} {value.family}
    </Text>
  );
};

interface NoteCellProps {
  value: string;
}

export const NoteCell = ({ value }: NoteCellProps) => {
  return <Text className={classes.noteValue}>{value}</Text>;
};
